module.exports = __webpack_public_path__ + "img/journal-arrow-down.a8b3d0ef.svg";